// extracted by mini-css-extract-plugin
export var container = "_2o-0";
export var error = "_2o-9";
export var label = "_2o-5";
export var light = "_2o-6";
export var md = "_2o-3";
export var sm = "_2o-2";
export var thin = "_2o-8";
export var thinBold = "_2o-7";
export var vertical = "_2o-4";
export var xs = "_2o-1";